module.exports = __webpack_public_path__ + "static/img/ger.bdf0edc4.png";